import { Button } from "@mui/material";
import baseUrl from "../../../features/services/service";
import { Salvage } from "Application/features/models/Home/Salvage";
import { SmallScreenDialog, SibaCarousel } from "@siba/components";
import { formatNumberCurrency, formatUKDate, useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { ExternalBid } from "Application/features/models/Home/ExternalBid";
import BidForm from "./BidForm";
import "./car-item.css";
import { useSaveExternalBidMutation } from "Application/features/services/apis/Home/ExternalBidApiService";
import { useGetSalvageByIdMutation } from "Application/features/services/apis/Home/SalvageExternalApiService";
import { growlError, userManagementUtil } from "@siba/utilities";
import { useEffect, useState } from "react";
import { queryResponse } from "Application/features/services/backends/sibaApis";

interface SalvageDetailsInterface {
    salvageId: string;
}
const SalvageDetails: React.FC<SalvageDetailsInterface> = (props) => {
    const { salvageId } = props;
    const [save] = useSaveExternalBidMutation();
    const [getSalvageById] = useGetSalvageByIdMutation();
    const [imageWithLinks, setImageWithLinks] = useState<string[]>([]);
    const [salvageDetails, setSalvageDetails] = useState<Salvage>({});
    const bidGenericMethods = useGenericFormMethods<ExternalBid>({
        formName: "Create Bid",
        saveMethod: save
    });
    const getSalvageDetail = async () => {
        const response: queryResponse<any> | any = await getSalvageById(salvageId);
        if (response && response.data) {
            setSalvageDetails(response.data);
            response.data.Images.forEach((x: string) => {
                setImageWithLinks((imageWithLinks) => [...imageWithLinks, `${baseUrl.backend}${x}`]);
            });
        }
    };
    const createBid = () => {
        if (userManagementUtil.getUserSession()) {
            bidGenericMethods.handleClickOpen();
            bidGenericMethods.formHandler.reset({
                SalvageId: salvageId,
                Status: "1",
                BidderName: `${userManagementUtil.getUserSession().firstName} ${userManagementUtil.getUserSession().lastName}`,
                BidderCode: userManagementUtil.getUserSession().BidderCode,
                PhoneNumber: userManagementUtil.getUserSession().phoneNumber,
                Email: userManagementUtil.getUserSession().email,
                Address: userManagementUtil.getUserSession().PostalAddress,
            });
        } else {
            return window.location.assign(window.location.origin + "/sibasalvage/login");
        }
    };
    useEffect(() => {
        try {
            getSalvageDetail();
        } catch (e) {
            growlError("Something went wrong");
        }
    }, []);

    return (
        <>
            <div style={{ padding: "1em" }}>
                <div className="row" style={{ paddingRight: "15px" }}>
                    <div className="col-md-6" style={{ paddingTop: "30px" }}>
                        <SibaCarousel width={550} images={imageWithLinks} />
                    </div>
                    <div className="col-md-6 carDetailsInfoMobile">
                        <h3 className="mb-3">Salvage Information</h3>
                        <div className="carDetailsInfoMobileLocation mb-3">
                            <div style={{ width: "60%", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                                <div style={{ width: "2%", height: "45px", backgroundColor: "#DF5000" }}>&nbsp;</div>
                                <div style={{ width: "98%", paddingLeft: "10px", display: "flex", flexDirection: "column" }}>
                                    <h6 style={{ fontSize: "12px", fontWeight: "400" }}>Location</h6>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Location || "Undisclosed"}</h4>
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    backgroundColor: "#949494",
                                    borderRadius: "10px",
                                    height: "50px",
                                    padding: "7px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <h6 style={{ fontSize: "13px", fontWeight: "400", color: "#fff" }}>
                                    Year Of <br /> Manufacture
                                </h6>

                                <div style={{ width: "50%", backgroundColor: "#FFF", borderRadius: "10px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>{salvageDetails.Year}</h4>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: "100%",
                                height: "130px",
                                padding: "10px",
                                backgroundColor: "#f2f2f2",
                                border: "1px solid #d5d5d5",
                                borderRadius: "15px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div style={{width: "100%", display: "flex", justifyContent: "space-between", borderBottom: "1px solid #d5d5d5", height: "60px"}}>
                                <div style={{ width: "50%", padding: "10px 10px 10px 0px", borderRight: "1px solid #d5d5d5" }}>
                                    <div style={{ marginBottom: "4px" }}>
                                        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Make}</h4>
                                    </div>
                                    <div>
                                        <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Make</h6>
                                    </div>
                                </div>
                                <div style={{ width: "50%", padding: "10px" }}>
                                    <div style={{ marginBottom: "4px" }}>
                                        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.StockNumber}</h4>
                                    </div>
                                    <div>
                                        <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Stock #</h6>
                                    </div>
                                </div>
                            </div>
                            <div style={{width: "100%"}}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Model}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Model</h6>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: "100%",
                                padding: "10px",
                                backgroundColor: "#f2f2f2",
                                border: "1px solid #d5d5d5",
                                borderRadius: "15px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                        >
                            <div style={{width: "100%", borderBottom: "1px solid #d5d5d5", padding: "10px 0px"}}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.VehicleNumber}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Registration Number</h6>
                                </div>
                            </div>
                            <div style={{width: "100%", borderBottom: "1px solid #d5d5d5", padding: "10px 0px"}}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.ChasisNumber}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Chasis Number</h6>
                                </div>
                            </div>
                            <div style={{width: "100%", borderBottom: "1px solid #d5d5d5", padding: "10px 0px"}}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Condition}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Salvage Description</h6>
                                </div>
                            </div>
                            <div style={{width: "100%", padding: "10px 0px"}}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{" "}
                                        {salvageDetails.BidCurrency || "GHS"} {formatNumberCurrency(salvageDetails.MinimumBidAmount) || 0.0}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Starting Bid Price</h6>
                                </div>
                            </div>
                        </div>
                        
                        <h3 className="mt-3">Bidding Information</h3>
                        <table className="mt-3 mb-2 table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <th>Number of Bidders</th>
                                    <td>{salvageDetails.NumberOfBidders || 0}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div style={{ width: "100%", justifyContent: "space-between", alignItems: "center", display: "flex", flexDirection: "column", marginTop: "15px" }}>
                            <div style={{ width: "100%" }}>
                                <div style={{ borderBottom: "1px solid #d5d5d5", width: "100%", padding: "10px 0px" }}>
                                    <div style={{ marginBottom: "4px" }}>
                                        <h4 className="blink" style={{ fontSize: "18px", fontWeight: "600" }}>{formatUKDate(salvageDetails.BidClosingDate) || "None"}</h4>
                                    </div>
                                    <div>
                                        <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Bid Closing Date</h6>
                                    </div>
                                </div>
                                <div style={{ borderBottom: "1px solid #d5d5d5", width: "100%", padding: "10px 0px" }}>

                                    <div style={{ marginBottom: "4px" }}>
                                        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{" "}
                                        {salvageDetails.BidCurrency || "GHS"} {formatNumberCurrency(salvageDetails.HighestBidAmount) || 0.0}</h4>
                                    </div>
                                    <div>
                                        <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Highest Bid Price</h6>
                                    </div>

                                </div>
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    border: "1px solid #d5d5d5",
                                    height: "80px",
                                    borderRadius: "15px",
                                    padding: "15px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "15px"
                                }}
                            >
                                <Button onClick={createBid} variant="contained" style={{ height: "100%", borderRadius: "10px", width: "100%", backgroundColor: "#F7001F" }}>
                                    Click to Bid
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 carDetailsInfoDesktop">
                        <h3 className="mb-3">Salvage Information</h3>
                        <div className="mb-3" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                            <div style={{ width: "60%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ width: "2%", height: "45px", backgroundColor: "#DF5000" }}>&nbsp;</div>
                                <div style={{ width: "98%", paddingLeft: "10px", display: "flex", flexDirection: "column" }}>
                                    <h6 style={{ fontSize: "12px", fontWeight: "400" }}>Location</h6>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Location || "Undisclosed"}</h4>
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "40%",
                                    backgroundColor: "#949494",
                                    borderRadius: "10px",
                                    height: "50px",
                                    padding: "7px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <h6 style={{ fontSize: "13px", fontWeight: "400", color: "#fff" }}>
                                    Year Of <br /> Manufacture
                                </h6>

                                <div style={{ width: "50%", backgroundColor: "#FFF", borderRadius: "10px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>{salvageDetails.Year}</h4>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: "100%",
                                height: "70px",
                                padding: "10px",
                                backgroundColor: "#f2f2f2",
                                border: "1px solid #d5d5d5",
                                borderRadius: "15px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div style={{ width: "30%" }}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.StockNumber}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Stock #</h6>
                                </div>
                            </div>
                            <div style={{ height: "35px", backgroundColor: "#000", width: "1px", borderRadius: "3px", transform: "translateY(0%) rotate(15deg)" }}>&nbsp;</div>
                            <div style={{ width: "32%", paddingLeft: "15px" }}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Make}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Make</h6>
                                </div>
                            </div>
                            <div style={{ height: "35px", backgroundColor: "#000", width: "1px", borderRadius: "3px", transform: "translateY(0%) rotate(15deg)" }}>&nbsp;</div>
                            <div style={{ width: "31%", paddingLeft: "15px" }}>
                                <div style={{ marginBottom: "4px" }}>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>{salvageDetails.Model}</h4>
                                </div>
                                <div>
                                    <h6 style={{ color: "#333333", fontSize: "12px", fontWeight: "400" }}>Model</h6>
                                </div>
                            </div>
                        </div>
                        <table className="mt-3 table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <th>Registration Number</th>
                                    <td>{salvageDetails.VehicleNumber}</td>
                                </tr>
                                <tr>
                                    <th>Chasis Number</th>
                                    <td>{salvageDetails.ChasisNumber}</td>
                                </tr>
                                <tr>
                                    <th>Salvage Description</th>
                                    <td>{salvageDetails.Condition}</td>
                                </tr>
                                <tr>
                                    <th>Starting Bid Price</th>
                                    <td>
                                        {" "}
                                        {salvageDetails.BidCurrency || "GHS"} {formatNumberCurrency(salvageDetails.MinimumBidAmount) || 0.0}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="mt-3">Bidding Information</h3>
                        <table className="mt-3 mb-3 table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <th>Number of Bidders</th>
                                    <td>{salvageDetails.NumberOfBidders || 0}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div style={{ width: "100%", justifyContent: "space-between", alignItems: "center", display: "flex", marginTop: "15px" }}>
                            <div style={{ width: "59%" }}>
                                <div style={{ borderBottom: "1px solid #d5d5d5", height: "37px", paddingBottom: "8px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>Bid Closing Date</h4>
                                    <h4 className="blink" style={{ fontSize: "16px", fontWeight: "400" }}>{formatUKDate(salvageDetails.BidClosingDate) || "None"}</h4>
                                </div>
                                <div style={{ borderBottom: "1px solid #d5d5d5", height: "37px", paddingBottom: "8px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                    <h4 style={{ fontSize: "16px", fontWeight: "600" }}>Highest Bid Price</h4>
                                    <h4 style={{ fontSize: "16px", fontWeight: "400" }}>
                                        {" "}
                                        {salvageDetails.BidCurrency || "GHS"} {formatNumberCurrency(salvageDetails.HighestBidAmount) || 0.0}
                                    </h4>
                                </div>
                            </div>
                            <div
                                style={{
                                    width: "38%",
                                    border: "1px solid #d5d5d5",
                                    height: "80px",
                                    borderRadius: "15px",
                                    padding: "15px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <Button onClick={createBid} variant="contained" style={{ height: "100%", borderRadius: "10px", width: "100%", backgroundColor: "#F7001F" }}>
                                    Click to Bid
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SmallScreenDialog title={"Place Bid"} onClose={bidGenericMethods.handleClickClose} visible={bidGenericMethods.modalOpen} onSave={bidGenericMethods.handleSave(bidGenericMethods.saveType)}>
                <BidForm formHandler={bidGenericMethods.formHandler} />
            </SmallScreenDialog>
        </>
    );
};

export default SalvageDetails;
